import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ActivatedRoute } from '@angular/router';
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import {NotificationService} from "../../services/notification/notification.service";
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/api';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-cotisations',
  templateUrl: './cotisations.component.html',
  styleUrls: ['./cotisations.component.scss']
})
export class CotisationsComponent implements OnInit {
  token: string;
  protected isACourtier = false;
  protected enableErrorMessageCourtier: Message[];
  constructor(private readonly translate: TranslateService,private route: ActivatedRoute,private readonly _: SourceAuthoritesAfterAuthenticationService,protected notificationService : NotificationService,protected sourceAuh: SourceAuthoritesAfterAuthenticationService, private readonly environmentService: EnvironmentService, private  readonly configurationService:ConfigurationService) {
    this.isFromCourtier()
   }
  configuration = this.configurationService.get();
  configurationPaiement = this.environmentService.get().paiementEnLigne;
  configurationCotisations=this.configurationService?.get()?.isFormActionDisabledCotisation;
  ngOnInit(): void {  }

  handleEmitAmountToPayEvent(_event: any) {
    this.notificationService.countAmountNotificationSubject.next(_event ? _event : 0);
  }
  private showCourtierMessage() {
    this.translate.get('cotisation.confidentialite.detail').subscribe((details)=>{
      this.enableErrorMessageCourtier = [
        { severity: 'error', summary: this.translate.instant('cotisation.confidentialite.summary'), detail:details }
      ];
    })
    
  }
  private isFromCourtier() {
    if (this.sourceAuh.accessDenied) {
      this.showCourtierMessage();
    }
  }
}
